import React from 'react';
import { FormPayment, FormPaymentPackage } from '@app/src/views/StepPayment/formPayment';
import { isClientEnv } from '@app/src/utils/validations';
import { useLocation } from 'react-router-dom';

const isClient = isClientEnv();

if (isClient) {
  (window as any).transaction = null;
}

export const StepPayment: React.FC = () => {
  const location = useLocation();

  const getAlias = () => location.pathname.split('/')[1].split('-')[1];

  return (
    <React.Fragment>
      {
        (getAlias() === 'paquete') ?
          <FormPaymentPackage />
          :
          <FormPayment />

      }
    </React.Fragment>
  )
};
